import { Box, styled } from "@mui/material";

export const Button = styled(Box)({
    display: 'grid',
    placeItems: 'center stretch',
    boxSizing: 'border-box',
    textAlign: 'center',
    lineHeight: '100%',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: '#f9f9f9'
    }
})